import React, { useContext, useEffect, useState, useRef } from 'react';
import { TicketContext } from '../../app/providers/TicketContext';
import { AuthContext } from '../../app/providers/AuthContext';
import './FullScreenLoader.css';

const FullScreenLoader = () => {
  const { loading: ticketLoading } = useContext(TicketContext);
  const { isAuthenticated, isLoggingIn, loginError, isCheckingSession } = useContext(AuthContext);
  const [showLoader, setShowLoader] = useState(!!localStorage.getItem('token'));
  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState('');
  const progressRef = useRef(null);

  const isFullyLoaded = !isCheckingSession && !isLoggingIn && !ticketLoading && isAuthenticated;

  useEffect(() => {
    if ((isCheckingSession || isLoggingIn || isAuthenticated) && !showLoader && !loginError) {
      setShowLoader(true);
      setFadeOut(false);
      setProgress(0);
    }

    if ((loginError || (!isAuthenticated && !isLoggingIn && !isCheckingSession)) && showLoader) {
      setShowLoader(false);
      setFadeOut(false);
    }
  }, [isCheckingSession, isLoggingIn, isAuthenticated, loginError]);

  useEffect(() => {
    if (!showLoader) return;

    if (isCheckingSession) {
      setProgress(10);
      setStatusText('Oturum doğrulanıyor');
    } else if (isLoggingIn) {
      setProgress(30);
      setStatusText('Oturum açılıyor');
    } else if (isAuthenticated && ticketLoading) {
      setProgress(60);
      setStatusText('Ticketlar yükleniyor');
    }

    if (isFullyLoaded) {
      setProgress(100);
      setStatusText('');

      const timeout = setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => setShowLoader(false), 400);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [isCheckingSession, isLoggingIn, isAuthenticated, ticketLoading, isFullyLoaded, showLoader]);

  useEffect(() => {
    if (!showLoader || isFullyLoaded) {
      if (progressRef.current) clearInterval(progressRef.current);
      return;
    }

    progressRef.current = setInterval(() => {
      setProgress(prev => {
        const ceiling = isCheckingSession ? 20 : isLoggingIn ? 45 : 85;
        if (prev >= ceiling) return prev;
        return prev + 0.4;
      });
    }, 200);

    return () => {
      if (progressRef.current) clearInterval(progressRef.current);
    };
  }, [showLoader, isCheckingSession, isLoggingIn, isFullyLoaded]);

  if (!showLoader) return null;

  return (
    <div className={`fullscreen-loader ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loader-brand">
        <div className="loader-brand-icon">J</div>
        <div className="loader-brand-name">Jubi</div>
      </div>

      <div className="loader-progress-track">
        <div
          className="loader-progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      {statusText && (
        <div className="loader-status">{statusText}</div>
      )}
    </div>
  );
};

export default FullScreenLoader;
